import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  name: '',
  brandId: '',
  projectId: null,
  integrationSystem: 'BrightPearl',
  integrationStatus: 'Active',
  integrationValid: false,
  integrationTrackingSyncIsEnabled: true,
  integrationInventorySyncIsEnabled: true,
  integrationInventorySyncAddInTransit: false,
  integrationRateIsEnabled: false,
  orderNumberPrefix: '',
  suffixOrderNumbers: '',
  apiKey: '',
  apiSecret: '',
  brightPearlAccountId: '',
  brightPearlWarehouseId: '',
  brightPearlOrderStatusIdFilter: '',
  brightPearlOrderStatusAfterCreation: '',
  brightPearlOrderStatusIdAfterShipped: '',
  brightPearlOrderTypeIdFilter: ''
};

let defaultFilters = {
  name: '',
  brandId: '',
  integrationSystem: null,
  integrationStatus: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  }
};
